import { NgModule } from '@angular/core';
import { SharedCommonModule } from '@spaq/shared';
import { SessionOOBLoaderComponent } from './components';

@NgModule({
	imports: [SharedCommonModule],
	declarations: [SessionOOBLoaderComponent],
	exports: [SessionOOBLoaderComponent]
})
export class SessionModule {}
